import { HugeiconsIcon } from "@hugeicons/react";
import {
  Alert02Icon,
  ChangeScreenModeIcon,
  Tick02Icon
} from "@hugeicons-pro/core-stroke-rounded";
import {
  CopyStatus,
  useCopyToClipboard
} from "shared/hooks/use-copy-to-clipboard";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";

const TOOLTIP_CONTENT = {
  [CopyStatus.Idle]: { icon: undefined, label: "Copy" },
  [CopyStatus.Copied]: { icon: Tick02Icon, label: "Copied" },
  [CopyStatus.Error]: { icon: Alert02Icon, label: "Failed to copy" }
};

export const CopyIconButton = ({
  value,
  idleAriaLabel,
  size = 14,
  strokeWidth = 1.5,
  stopPropagation = false,
  className = ""
}: {
  value: string;
  idleAriaLabel: string;
  size?: number;
  strokeWidth?: number;
  stopPropagation?: boolean;
  className?: string;
}) => {
  const { status, copy, reset } = useCopyToClipboard();
  const { icon, label } = TOOLTIP_CONTENT[status];

  return (
    <Tooltip placement="top">
      <TooltipTrigger
        aria-label={status === CopyStatus.Idle ? idleAriaLabel : label}
        className={`shrink-0 text-content-400 hover:text-content-600 transition-colors focus:outline-1 focus:outline-primary-500 rounded ${className}`}
        onMouseEnter={reset}
        onFocus={reset}
        onClick={(e) => {
          if (stopPropagation) {
            e.preventDefault();
            e.stopPropagation();
          }
          value && copy(value);
        }}
      >
        <HugeiconsIcon
          icon={ChangeScreenModeIcon}
          size={size}
          strokeWidth={strokeWidth}
        />
      </TooltipTrigger>
      <TooltipContent className="border border-white/40 rounded-[11px] px-4 py-3 text-sm text-content-1000-inverted z-[13] flex items-center justify-center gap-2">
        {icon ? <HugeiconsIcon icon={icon} size={24} strokeWidth={1} /> : null}
        {label}
      </TooltipContent>
    </Tooltip>
  );
};
